import { useEffect, useRef, useState } from "react";
import { getStreamDocument } from "../lib/api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { ChevronLeft, ChevronRight } from "../shared/svgIcon";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const isBrowser = typeof document !== "undefined";
export default function PatientReport({ documentId, consumerId, style }) {
  const [fileUrl, setFileUrl] = useState(null);
  const divRef = useRef(null);
  const [divWidth, setDivWidth] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [width, setWindowWidth] = useState(
    isBrowser ? window.innerWidth : null
  );
  const [height, setWindowHeight] = useState(
    isBrowser ? window.innerHeight : null
  );

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }
  useEffect(() => {
    if (divRef.current) {
      setDivWidth(divRef.current.clientWidth);
    }
  }, []);
  const location = useLocation();
  const consumer_id =
    new URLSearchParams(location.search).get("consumer_id") || consumerId;
  const document_id =
    new URLSearchParams(location.search).get("document_id") || documentId;
  const { isPending, error, data } = useQuery({
    queryKey: ["getStreamDocument"],
    queryFn: () =>
      getStreamDocument({
        doc_id: document_id,
        consumer_id: consumer_id,
      }),
  });
  //     if (isPending) return 'Loading...'

  //   if (error) return 'An error has occurred: ' + error.message
  if (data) {
    const file = new Blob([data], { type: "application/pdf" });

    const fileURL = window.URL.createObjectURL(file);
    // console.log(fileURL);
    const iframe = document.querySelector("iframe");
    if (iframe?.src) iframe.src = fileURL;
    if (!fileUrl) {
      setFileUrl(fileURL);
    }
  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  useEffect(() => {
    const calculateWidths = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };

    calculateWidths();
    window.addEventListener("resize", calculateWidths);

    return () => {
      window.removeEventListener("resize", calculateWidths);
    };
  }, []);
  return (
    <div className="w-full h-screen " ref={divRef}>
      {/* <iframe title="patientReport" src="" width="100%" height="100%"></iframe> */}

      {fileUrl && (
        <>
          {" "}
          <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
            {/* {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={divWidth}
              />
            ))} */}
            <div
              style={{
                width: "100%",
                height: "100vh",
                overflow: "auto",
                display: "flex",
                justifyContent: "center",
                backgroundColor: "white",
                ...style,
              }}
            >
              <Page
                width={width < 768 ? 0.9 * width : 0.6 * width}
                height={100}
                pageNumber={pageNumber}
              />
            </div>
          </Document>
          <div className="flex justify-center items-center h-11 fixed z-10  bottom-1 bg-white border  rounded shadow-md  left-1/2 transform -translate-x-1/2">
            <button
              type="button"
              disabled={pageNumber <= 1}
              onClick={previousPage}
              className="flex justify-center items-center h-full px-2 hover:bg-slate-200"
            >
              <ChevronLeft width={"16px"} height={"16px"} />
            </button>
            <p className="p-3">
              {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
            </p>
            <button
              type="button"
              disabled={pageNumber >= numPages}
              onClick={nextPage}
              className="flex justify-center items-center h-full px-2 hover:bg-slate-200"
            >
              <ChevronRight width={"16px"} height={"16px"} />
            </button>
          </div>
        </>
      )}
    </div>
  );
}
